import { ButtonFill } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledButtonFilled = styled(ButtonFill)`
  width: 12.5rem;
`
